import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Navbar from "../../../layout/Navbar";
import FinanceSidebar from "./FinanceSidebar";

export default function FinanceLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="app-shell">
      <FinanceSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="app-main">
        <Navbar onMenuToggle={() => setSidebarOpen((open) => !open)} />

        <main className="app-content">
          <div key={location.pathname} className="content-inner page-enter">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
